import React, { Component } from 'react';
import { API_URL } from "../../config/Config";
import axios from "axios/index";
import axiosRetry from 'axios-retry';
import { connect } from 'react-redux';

axiosRetry(axios, { retries: 3 });



class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cities: []
        }

    }

    componentDidMount() {
        this.getStatesAndCities();
    }

    async getStatesAndCities() {
        let response = await axios.get(`${API_URL}state-city`);

        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);
        } else {
            let cites = response.data.cites;
            this.setState({
                cities: cites
            })

        }
    }

    render() {
        const categories = this.props;

        return (
            <div className="vertical-Search-box">
                <div className="findit" >
                    <span>پیدا کن ....</span>
                    <div className="input-group mb-3">
                        <input type="text" className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" />
                    </div>
                </div>
                <div className="Search-category">
                    <span>دسته بندی</span>
                    <div className="input-group mb-3">
                        <select className="custom-select" id="inputGroupSelect01" >
                            <option >انتخاب کنید</option>
                            {categories.categories !== undefined && categories.categories.map((category, i) => {
                                return (
                                    <option key={i} value={category.id}>{category.name}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <div className="Search-category">
                    <span>شهر</span>
                    <div className="input-group mb-3">
                        <select className="custom-select" id="inputGroupSelect01" >
                            <option >انتخاب کنید</option>
                            {this.state.cities !== undefined && this.state.cities.map((city, i) => {
                                return (
                                    <option key={i} value={city.id}>{city.name}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <button className="btn search-but" type="button" >برو..</button>
            </div>

        )
    }

}

function mapStateToProps(state) {
    return { categories: state.categories.items };
}

export default connect(
    mapStateToProps, null
)(Search);


// WEBPACK FOOTER //
// ./src/components/search/search.jsx